<template lang="html">
  <section>
    <div :id="elementId" class="card-header-container">
      <div class="header-icon" v-if="hasRightIcon">
        <svg :style="'background-color:' + icon.color">
          <use :xlink:href="icon.url"></use>
        </svg>
      </div>

      <div class="header-title">
        <span v-if="isLink">
          <a class="link-header" @click="onHeaderClicked">
            {{ headerTitle }}
          </a>
        </span>
        <span v-else>{{ headerTitle }}</span>
      </div>

      <div v-if="hasRightActions()"><slot name="actions">Footer</slot></div>
    </div>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";

  export default  {
    name: 'card-header',
    props: {
      id: {
        type: String
      },
      icon: {
        type: Object
      },
      headerTitle: {
        type: String
      },
      isLink: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      hasRightIcon() {
        return Boolean(this.icon && this.icon.id);
      },
      elementId() {
        return this.id || `card-header-${uuidv4()}`;
      }
    },
    mounted () {
    },
    data () {
      return {
      }
    },
    methods: {
      hasRightActions() {
        return !!this.$slots.actions;
      },
      onHeaderClicked() {
        this.$emit("on-card-header-click", this.id || this.elementId);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";

  .header-icon {
    svg {
      @include mixin-list-item-svg-icon;
      margin: 0 0.7rem 0 0;
      padding: 0;
    }
  }
  .card-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .header-title {
    font-size: 1rem;
    font-weight: bold;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 0.2rem;
    flex: auto;
  }

  .link-header {
    color: inherit;
  }

  .link-header:active,
  .link-header:hover,
  .link-header:focus {
    color: var(--LINK_ACTIVE);
  }
</style>
